var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.showSelectMealsForm)?_c('RegisterSelectMealsForm',_vm._g({},_vm.$listeners)):_vm._e(),(_vm.showAllMealsForm)?_c('RegisterSelectAllMealsForm',_vm._g({},_vm.$listeners)):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }